export const MEDIA = {
  lobby1: "/images/lobby1.webp",
  lobby2: "/images/lobby2.webp",
  heroNurse: "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  smilingSeniors: "https://images.pexels.com/photos/8153907/pexels-photo-8153907.jpeg?auto=compress&cs=tinysrgb&w=800",
  seniorsTalking: "https://images.unsplash.com/photo-1764173039543-f9f197744e1b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  elderlyDancing: "https://images.unsplash.com/photo-1773227059529-3a2bd04ce5b0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  homeCare: "https://images.unsplash.com/photo-1691139601099-932c01ec198b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  heroInterior: "/images/hero-caregiver.webp",
  childRespite: "https://images.pexels.com/photos/8613089/pexels-photo-8613089.jpeg?auto=compress&cs=tinysrgb&w=800",
  seniorPortrait: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  softLight: "https://images.unsplash.com/photo-1511836536898-6d6f1b8f6948?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  cityMontreal: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Mtl_from_mont_royal_%28cropped%29.jpg/960px-Mtl_from_mont_royal_%28cropped%29.jpg",
  cityOutaouais: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Gatineau_-_QC_-_Museum_of_Civilisation3.jpg/960px-Gatineau_-_QC_-_Museum_of_Civilisation3.jpg",
  cityMauricie: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Trois-Rivi%C3%A8res%2C_Quebec_%28cropped%292.jpg/960px-Trois-Rivi%C3%A8res%2C_Quebec_%28cropped%292.jpg",
  cityOttawa: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Parliament-Ottawa.jpg/960px-Parliament-Ottawa.jpg",
};

export const REGION_CREDITS = [
  "Photo : Vreee — CC BY-SA 4.0",
  "Photo : Wladyslaw — CC BY 3.0",
  "Photo : Quintin Soloviev — CC BY 4.0",
  "Photo : Arctic.gnome — CC BY 2.5",
];

export const CONTACT_INFO = {
  phone: "514-464-5880",
  phoneHref: "tel:+15144645880",
  email: "info@ghap-hlpg.ca",
};
